import { useEffect } from "react"
import useStore from "@state/store"
import { useSyncStatesWithSocket } from "@utils/useSyncStatesWithSockets"

export function useCoordinatedLoading(device: "tablet" | "screen") {
  const { syncStatesWithSocket: syncState } = useSyncStatesWithSocket()
  const tabletLoaded = useStore((state) => state.tabletLoaded)
  const screenLoaded = useStore((state) => state.screenLoaded)
  const loaded = useStore((state) => state.loaded)

  useEffect(() => {
    // Set timeout for 3 seconds
    const timeout = setTimeout(() => {
      if (!loaded) {
        console.log("Loading timeout reached, forcing loaded state")
        syncState({ loaded: true })
      }
    }, 6000)

    // Check if both devices are loaded
    if (tabletLoaded && screenLoaded && !loaded) {
      syncState({ loaded: true })
    }

    return () => clearTimeout(timeout)
  }, [tabletLoaded, screenLoaded, loaded])

  return loaded
}
